<template>
  <v-app-bar app flat clipped-left clipped-right="" fixed color="white" height="48" class="elevation-2">

    <v-toolbar-title>
      <a href="https://www.connectedeasternsierra.net"
         target="_blank">
        <img src="https://connectedeasternsierra.net/wp-content/uploads/2019/06/CESierra-Logo-1.jpg"
             alt="Connected Eastern Sierra"
             height="40"
        />
      </a>
      <!--      <a href="https://www.connectedeasternsierra.net"-->
      <!--         target="_blank">-->
      <!--        <img src="../../assets/CESierra-Logo.Horiz.png"-->
      <!--             alt="Connected Eastern Sierra"-->
      <!--             height="20"-->
      <!--        />-->
      <!--      </a>-->
    </v-toolbar-title>

    <v-toolbar-title class="ml-4 title secondary--text">
      <v-btn href="/" text>
        <div class="title">
          <span class="primary--text">Broadband</span> Access Tool
        </div>
      </v-btn>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <NavBar v-if="$vuetify.breakpoint.mdAndUp"/>

    <template v-slot:extension v-if="$vuetify.breakpoint.smAndDown">
      <NavBar/>
    </template>

  </v-app-bar>

</template>

<script>
import NavBar from './NavBar';

export default {
  name: 'Toolbar',
  components: { NavBar },
};
</script>
